import React, { useState, useEffect, useCallback } from 'react';
import { getEnderecoSugestoes, validarEnderecoEntrega, getEnderecoCompleto } from '../services/api';

function BuscaEndereco({ onSelected, brand }) {
  const [endereco, setEndereco] = useState('');
  const [sugestoes, setSugestoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingValidacao, setLoadingValidacao] = useState(false);
  const [enderecoInvalido, setEnderecoInvalido] = useState(null);

  // Debounce para busca de sugestões
  const debounceSearch = useCallback(
    (() => {
      let timeoutId;
      return (searchTerm) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          buscarSugestoes(searchTerm);
        }, 500);
      };
    })(),
    []
  );

  const handleInputChange = (e) => {
    const valor = e.target.value;
    setEndereco(valor);
    
    if (valor.length >= 3) {
      setLoading(true);
      debounceSearch(valor);
    } else {
      setSugestoes([]);
      setLoading(false);
    }
  };

  const buscarSugestoes = async (termo) => {
    try {
      const resultado = await getEnderecoSugestoes(termo);
      setSugestoes(resultado.predictions || []);
    } catch (error) {
      setSugestoes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSugestaoClick = async (sugestao) => {
    setEndereco(sugestao.description);
    setSugestoes([]);
    setLoadingValidacao(true);
    setEnderecoInvalido(null);
    
    try {
      
      // 1. Sitri → Xerxes (coordenadas)
      const coordenadas = await getEnderecoCompleto(sugestao.description);
      
      if (coordenadas && coordenadas.lat && coordenadas.lng) {
        
        // 2. Sitri → Lucifer (validação zona)
        const validacao = await validarEnderecoEntrega(
          brand, 
          sugestao.description, 
          null, 
          parseFloat(coordenadas.lat), 
          parseFloat(coordenadas.lng)
        );
        
        
        if (validacao && validacao.success) {
          setEnderecoInvalido(null);
          onSelected({
            endereco: sugestao.description,
            place_id: sugestao.place_id,
            lat: parseFloat(coordenadas.lat),
            lng: parseFloat(coordenadas.lng),
            entrega: validacao.entrega
          });
        } else {
          setEnderecoInvalido(validacao?.message || 'Endereço não válido');
        }
      } else {
        setEnderecoInvalido('Não foi possível obter coordenadas do endereço');
      }
    } catch (error) {
      setEnderecoInvalido('Erro ao validar endereço');
    } finally {
      setLoadingValidacao(false);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className="form-floating">
        <input 
          type="text" 
          className="form-control" 
          value={endereco}
          onChange={handleInputChange}
          placeholder="Digite um endereço com número"
          autoComplete="off"
          style={{ fontSize: '15px' }}
        />
        <label>Digite um endereço com número</label>
      </div>

      {loading && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
          textAlign: 'center',
          zIndex: 1000
        }}>
          Buscando sugestões...
        </div>
      )}

      {loadingValidacao && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
          textAlign: 'center',
          zIndex: 1000
        }}>
          Validando endereço...
        </div>
      )}

      {enderecoInvalido && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #dc3545',
          borderRadius: '5px',
          padding: '10px',
          color: '#dc3545',
          fontSize: '14px',
          zIndex: 1000
        }}>
          ⚠️ {enderecoInvalido}
        </div>
      )}

      {sugestoes.length > 0 && !loading && !loadingValidacao && !enderecoInvalido && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '5px',
          marginTop: '5px',
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <ul style={{ 
            listStyle: 'none', 
            padding: '10px', 
            margin: 0 
          }}>
            {sugestoes.map((sugestao, index) => (
              <li 
                key={index}
                style={{
                  padding: '8px',
                  cursor: 'pointer',
                  borderBottom: index < sugestoes.length - 1 ? '1px solid #eee' : 'none',
                  textAlign: 'left'
                }}
                onClick={() => handleSugestaoClick(sugestao)}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {sugestao.structured_formatting?.main_text || sugestao.description}
                </div>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#666',
                  marginTop: '2px'
                }}>
                  {sugestao.structured_formatting?.secondary_text || ''}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default BuscaEndereco;